// extracted by mini-css-extract-plugin
export default {"filtersBtn":"styles_filtersBtn__NWr5v","active":"styles_active__tHcP5"};